import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Heroimg2 from '../components/Heroimg2';
import AboutContent from '../components/AboutContent';

function About() {
  return (
    <div>
       <Navbar/>
       <Heroimg2 heading="BETHEL KENS." text="Im a friendly Web, 
       Mobile and Desktop Developer."/>
       <AboutContent/>
      <Footer/>
    </div>
  )
}

export default About